import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/inherits";
import * as React from "react";
import { SearchkitComponent, renderComponent } from "../../../../core";
import { FilterGroup } from "../../../ui";

var defaults = require("lodash/defaults");

var groupBy = require("lodash/groupBy");

var size = require("lodash/size");

var toArray = require("lodash/toArray");

var forEach = require("lodash/forEach");

var map = require("lodash/map");

export var GroupedSelectedFilters =
/*#__PURE__*/
function (_SearchkitComponent) {
  _inherits(GroupedSelectedFilters, _SearchkitComponent);

  function GroupedSelectedFilters(props) {
    var _this;

    _classCallCheck(this, GroupedSelectedFilters);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(GroupedSelectedFilters).call(this, props));
    _this.translate = _this.translate.bind(_assertThisInitialized(_this));
    _this.removeFilter = _this.removeFilter.bind(_assertThisInitialized(_this));
    _this.removeFilters = _this.removeFilters.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(GroupedSelectedFilters, [{
    key: "defineBEMBlocks",
    value: function defineBEMBlocks() {
      var blockName = this.props.mod || "sk-filter-groups";
      return {
        container: blockName
      };
    }
  }, {
    key: "getFilters",
    value: function getFilters() {
      return this.getQuery().getSelectedFilters();
    }
  }, {
    key: "getGroupedFilters",
    value: function getGroupedFilters() {
      var filters = this.getFilters();
      return toArray(groupBy(filters, 'id'));
    }
  }, {
    key: "hasFilters",
    value: function hasFilters() {
      return size(this.getFilters()) > 0;
    }
  }, {
    key: "removeFilter",
    value: function removeFilter(filter) {
      filter.remove();
      this.searchkit.performSearch();
    }
  }, {
    key: "removeFilters",
    value: function removeFilters(filters) {
      forEach(filters, function (filter) {
        return filter.remove();
      });
      this.searchkit.performSearch();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var groupComponent = this.props.groupComponent;

      if (!this.hasFilters()) {
        return null;
      }

      return React.createElement("div", {
        className: this.bemBlocks.container()
      }, map(this.getGroupedFilters(), function (filters) {
        return renderComponent(groupComponent, {
          key: filters[0].id,
          className: filters[0].id ? "filter-group-".concat(filters[0].id) : undefined,
          title: _this2.translate(filters[0].name),
          filters: filters,
          translate: _this2.translate,
          removeFilter: _this2.removeFilter,
          removeFilters: _this2.removeFilters
        });
      }));
    }
  }]);

  return GroupedSelectedFilters;
}(SearchkitComponent);
GroupedSelectedFilters.propTypes = defaults({}, SearchkitComponent.propTypes);
GroupedSelectedFilters.defaultProps = {
  groupComponent: FilterGroup
};